module.exports = __webpack_public_path__ + "img/logo-taptasty.ea228192.png";